import { MessageCircle } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const PHONE = "41817231642"; // wa.me number, no plus, no spaces

const COPY = {
  de: {
    aria: "Per WhatsApp anfragen",
    text: "Grüezi Fritz Kamm AG, ich habe eine Anfrage zu einem Galvanik-Verfahren.",
  },
  en: {
    aria: "Contact via WhatsApp",
    text: "Hello Fritz Kamm AG, I have an inquiry about an electroplating process.",
  },
  fr: {
    aria: "Contacter via WhatsApp",
    text: "Bonjour Fritz Kamm SA, j'ai une demande concernant un procédé de galvanoplastie.",
  },
  it: {
    aria: "Contattare via WhatsApp",
    text: "Buongiorno Fritz Kamm SA, ho una richiesta su un procedimento galvanico.",
  },
};

export default function WhatsAppButton() {
  const { lang } = useI18n();
  const c = COPY[lang] || COPY.de;
  const text = encodeURIComponent(c.text);
  return (
    <a
      data-testid="whatsapp-button"
      href={`https://wa.me/${PHONE}?text=${text}`}
      target="_blank"
      rel="noreferrer"
      aria-label={c.aria}
      className="fixed z-[60] bottom-6 left-[88px] w-12 h-12 flex items-center justify-center bg-[#25D366] text-white shadow-2xl hover:scale-105 transition-transform"
      style={{ borderRadius: 0 }}
    >
      <svg viewBox="0 0 32 32" className="w-5 h-5" fill="currentColor" aria-hidden="true">
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.478-1.318.13-.33.187-.66.187-.99 0-.43-1.69-1.218-2.063-1.32zm-2.91 7.41c-1.74 0-3.434-.482-4.94-1.366L4.66 25.236l1.99-7.302c-.95-1.566-1.43-3.376-1.43-5.236 0-5.7 4.69-10.4 10.4-10.4 2.79 0 5.41 1.084 7.382 3.057a10.4 10.4 0 0 1 3.057 7.36c0 5.71-4.69 10.4-10.4 10.4zm0-22.74C9.532 1.875 3.875 7.532 3.875 14.49c0 2.182.572 4.297 1.658 6.18L3.5 28.07l7.59-1.998a12.59 12.59 0 0 0 6.07 1.547h.005c6.997 0 12.71-5.713 12.71-12.704A12.66 12.66 0 0 0 16.2 1.875z"/>
      </svg>
    </a>
  );
}
